import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Role } from '../../../shared/models';
import { UsersService } from '../../../users.service';

@Component({
  selector: 'app-roles-for-user',
  templateUrl: './roles-for-user.component.html',
  styleUrls: ['./roles-for-user.component.scss'],
})
export class RolesForUserComponent implements OnInit {
  @Input() roles: number[];
  @Input() rolesBS: BehaviorSubject<Role[]>;
  @Output() rolesSelection: EventEmitter<number[]> = new EventEmitter();

  companyRoles = [];
  companySet: Set<number> = new Set();
  alcmeonRoles = [];
  alcmeonSet: Set<number> = new Set();

  cannotAddRoles = false;

  constructor(private usersService: UsersService) {}

  ngOnInit(): void {
    this.rolesBS.subscribe(value => {
      if (value) {
        this.dispatchRoles(value);
      }
    });
  }

  private dispatchRoles(roles: Role[]) {
    this.companyRoles = [];

    this.alcmeonRoles = [];
    (roles || []).forEach((role: Role) => {
      if (role.is_static) {
        this.alcmeonRoles.push(role);
      } else {
        this.companyRoles.push(role);
      }
    });
    (this.roles || []).forEach((roleId: number) => {
      const role = this.usersService.roleMap.get(roleId);

      if (role) {
        if (role.is_static) {
          this.alcmeonSet.add(role.id);
        } else {
          this.companySet.add(role.id);
        }
      }
      this.checkNumberOfRoles();
    });
  }

  roleSelectionChanged({ checked }, roleId) {
    if (checked) {
      this.companySet.add(roleId);
    } else {
      this.companySet.delete(roleId);
    }
    this.checkNumberOfRoles();
    this.rolesSelection.emit([].concat(...this.companySet).concat(...this.alcmeonSet));
  }

  private checkNumberOfRoles() {
    this.cannotAddRoles = this.alcmeonSet.size + this.companySet.size >= this.usersService.MAX_ROLES_TO_ATTACH;
  }
}
